"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACTION = void 0;
/** Actions specific to the fee payment networks */
var ACTION;
(function (ACTION) {
    // Standard referenceBased
    ACTION["CREATE"] = "create";
    ACTION["ADD_PAYMENT_ADDRESS"] = "addPaymentAddress";
    ACTION["ADD_REFUND_ADDRESS"] = "addRefundAddress";
    // Specific to FeeReferenceBased
    ACTION["ADD_FEE"] = "addFee";
})(ACTION || (exports.ACTION = ACTION = {}));
//# sourceMappingURL=pn-any-fee-reference-based-types.js.map